import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { RedirectCommand, Router, UrlTree } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { CartItem } from '@pedix-workspace/utils';
import { AppCartItemsService } from '../../../app-cart-items.service';
import { AppRequestContextService } from '../../../app-request-context.service';
import {
  REPEAT_ORDER_REMOVED_NAMES_STATE_KEY,
  RepeatOrderStateService,
} from './repeat-order-state.service';

export async function restoreCartItemsAndGoToResume(
  sourceId: string,
  loadCartItems: (establishmentId: string) => Observable<CartItem[] | null>,
): Promise<boolean | UrlTree | RedirectCommand> {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (isPlatformServer(platformId)) {
    return true;
  }

  const cartItemsService = inject(AppCartItemsService);
  const requestContext = inject(AppRequestContextService);
  const repeatOrderState = inject(RepeatOrderStateService);

  const catalog = requestContext.catalog();
  const homeUrl = router.createUrlTree(['/']);

  if (!catalog) {
    return homeUrl;
  }

  const establishmentId = catalog.establishment.id;
  const resumeUrl = router.createUrlTree(['resumen']);

  if (repeatOrderState.wasRepeated(establishmentId, sourceId) && !cartItemsService.isCartEmpty()) {
    return resumeUrl;
  }

  try {
    const cartItems = await firstValueFrom(loadCartItems(establishmentId));

    if (!cartItems) {
      return homeUrl;
    }

    const { removedCartItems } = cartItemsService.repeatCartItems(cartItems, catalog);

    repeatOrderState.markRepeated(establishmentId, sourceId);

    const removedProductNames = [
      ...new Set(removedCartItems.map(cartItem => cartItem.product.name)),
    ];

    return new RedirectCommand(resumeUrl, {
      state: { [REPEAT_ORDER_REMOVED_NAMES_STATE_KEY]: removedProductNames },
    });
  } catch {
    return homeUrl;
  }
}
